import {RefObject, useCallback, useEffect, useState} from "react";
import Uppy from '@uppy/core';
import Tus from '@uppy/tus';
import FileInput from '@uppy/file-input';
import {Endpoints, TFile} from "@brg/api";

export type UploadedImage = Omit<Uppy.UppyFile, 'progress'> & {
    progress: number | undefined;
    url: string;
    src?: string;
};

type ImagePreview = { name: string; src: string };
type FileInputRef = RefObject<Element | undefined>;

export function createUppy(fileRef: FileInputRef, handler: (files: UploadedImage[]) => void): Uppy.Uppy {
    return Uppy().use(Tus, {
        endpoint: `${Endpoints.uploader}/upload/`,
        chunkSize: 4194304
    })
        .use(FileInput, {
            target: fileRef.current ?? undefined,
            id: 'fileRef',
            pretty: true,
            inputName: 'files[]',
            locale: {}
        })
        .on('complete', (result: Uppy.UploadResult) => {
            if (!!result?.successful?.length) {

                const results = result.successful.map((item) => {
                    const url = item.uploadURL
                    const linkT = url.split('/')
                    const lngh = linkT.length - 1
                    const id = linkT[lngh];
                    const progress = item?.progress?.percentage;

                    return {
                        ...item,
                        progress,
                        url: id,
                        id
                    }

                })

                handler(results)
            }
        })
}

export const useUppyLoader = (
    files: readonly (File | TFile)[],
    fileRef: FileInputRef,
    handler: (complete: boolean) => void,
    time: number,
): [Uppy.Uppy, UploadedImage[]] => {
    const [data, setData] = useState<UploadedImage[]>([]);
    const [src, setSrc] = useState<ImagePreview[]>([]);
    const [images, setImages] = useState<UploadedImage[]>([]);
    const [uploadCompelete, setUploadCompelete] = useState(false);
    const onUploadComplete = useCallback((files: UploadedImage[]) => {
        setImages(files);
        setUploadCompelete(true);
        handler(uploadCompelete);
    }, [images, uploadCompelete])

    const [uppy] = useState(() => createUppy(fileRef, onUploadComplete))

    useEffect(() => {
        if (files?.length) {
            const srcHere: ImagePreview[] = [];
            uppy.reset();

            files.forEach((file) => {
                if (!(file instanceof File)) return;
                const fr = new FileReader();
                try {
                    uppy.addFile({
                        source: 'file input',
                        name: file.name,
                        type: file.type || 'application/octet-stream',
                        data: file,
                        meta: {
                            contentType: file.type || 'application/octet-stream'
                        }
                    })
                } catch (err: unknown) {
                    if (err instanceof Error && 'isRestriction' in err && err.isRestriction) {
                        // handle restrictions
                        console.error('Restriction error:', err)
                    } else {
                        // handle other errors
                        console.error(err)
                    }
                }

                fr.onload = () => {
                    if (typeof fr.result === 'string') {
                        srcHere.push({ name: file.name, src: fr.result });
                    }
                }


                fr.readAsDataURL(file)
            })

            setSrc(srcHere)
            uppy.upload()
        }

    } , [files, uppy])

    useEffect(() => {
        if (images?.length) {
            setData(images.map((img) => {
                const s = src.find((s) => s.name === img.name);
                if (s) {
                    return {
                        ...img,
                        src: s?.src
                    }
                }
                return img
            }))
        }
    } , [src, images])

    useEffect(() => {
        setData([]);
    } , [time])

    return [uppy, data]
}
import {RefObject, useCallback, useEffect, useState} from "react";
import Uppy from '@uppy/core';
import Tus from '@uppy/tus';
import FileInput from '@uppy/file-input';
import {Endpoints, TFile} from "@brg/api";

export type UploadedImage = Omit<Uppy.UppyFile, 'progress'> & {
    progress: number | undefined;
    url: string;
    src?: string;
};

type ImagePreview = { name: string; src: string };
type FileInputRef = RefObject<Element | undefined>;

export function createUppy(fileRef: FileInputRef, handler: (files: UploadedImage[]) => void): Uppy.Uppy {
    return Uppy().use(Tus, {
        endpoint: `${Endpoints.uploader}/upload/`,
        chunkSize: 4194304
    })
        .use(FileInput, {
            target: fileRef.current ?? undefined,
            id: 'fileRef',
            pretty: true,
            inputName: 'files[]',
            locale: {}
        })
        .on('complete', (result: Uppy.UploadResult) => {
            if (!!result?.successful?.length) {

                const results = result.successful.map((item) => {
                    const url = item.uploadURL
                    const linkT = url.split('/')
                    const lngh = linkT.length - 1
                    const id = linkT[lngh];
                    const progress = item?.progress?.percentage;

                    return {
                        ...item,
                        progress,
                        url: id,
                        id
                    }

                })

                handler(results)
            }
        })
}

export const useUppyLoader = (
    files: readonly (File | TFile)[],
    fileRef: FileInputRef,
    handler: (complete: boolean) => void,
    time: number,
): [Uppy.Uppy, UploadedImage[]] => {
    const [data, setData] = useState<UploadedImage[]>([]);
    const [src, setSrc] = useState<ImagePreview[]>([]);
    const [images, setImages] = useState<UploadedImage[]>([]);
    const [uploadCompelete, setUploadCompelete] = useState(false);
    const onUploadComplete = useCallback((files: UploadedImage[]) => {
        setImages(files);
        setUploadCompelete(true);
        handler(uploadCompelete);
    }, [images, uploadCompelete])

    const [uppy] = useState(() => createUppy(fileRef, onUploadComplete))

    useEffect(() => {
        if (files?.length) {
            const srcHere: ImagePreview[] = [];
            uppy.reset();

            files.forEach((file) => {
                if (!(file instanceof File)) return;
                const fr = new FileReader();
                try {
                    uppy.addFile({
                        source: 'file input',
                        name: file.name,
                        type: file.type || 'application/octet-stream',
                        data: file,
                        meta: {
                            contentType: file.type || 'application/octet-stream'
                        }
                    })
                } catch (err: unknown) {
                    if (err instanceof Error && 'isRestriction' in err && err.isRestriction) {
                        // handle restrictions
                        console.error('Restriction error:', err)
                    } else {
                        // handle other errors
                        console.error(err)
                    }
                }

                fr.onload = () => {
                    if (typeof fr.result === 'string') {
                        srcHere.push({ name: file.name, src: fr.result });
                    }
                }


                fr.readAsDataURL(file)
            })

            setSrc(srcHere)
            uppy.upload()
        }

    } , [files, uppy])

    useEffect(() => {
        if (images?.length) {
            setData(images.map((img) => {
                const s = src.find((s) => s.name === img.name);
                if (s) {
                    return {
                        ...img,
                        src: s?.src
                    }
                }
                return img
            }))
        }
    } , [src, images])

    useEffect(() => {
        setData([]);
    } , [time])

    return [uppy, data]
}
